export enum TaskAction {
  COMPLETE = 1,
  POSTPONE = 2,
  IGNORE = 3,
  REPLY = 4
}

export enum GoalTaskTypeEnum {
  SIMPLE = 'SIMPLE',
  PERMANENT = 'PERMANENT',
  RECURRING = 'RECURRING'
}

export enum GoalTaskTypeBackendEnum {
  SIMPLE = 1,
  PERMANENT = 2,
  RECURRING = 3
}

export enum GoalTypeEnum {
  REDUCE_SIDE_EFFECTS = 1,
  MANAGE_CONDITIONS = 2,
  SIMPLIFY_MEDICATION_REGIMEN = 3,
  SAVE_MONEY = 4
}

export interface IGoalTask {
  id: number
  title: string
  description: string
  type: GoalTaskTypeEnum | string
  status: string
  order_number: number
  navigate: string | null
  pre_populated: boolean
  reply: string | null
  tags: string[]
  _created: Date
}

export interface IMemberGoal {
  id: number
  goal_id: GoalTypeEnum
  status: number
  name: string
  notes: string
  _created: Date
  action_plan: {
    active: IGoalTask[]
    completed: IGoalTask[]
    postponed: IGoalTask[]
    ignored: IGoalTask[]
  }
}

export interface IAddGoalTask {
  title: string
  description: string
  type: GoalTaskTypeBackendEnum
}

export interface GoalsStore {
  getMemberGoals: (userId: number) => Promise<IMemberGoal | null>
  sendTaskAction: (
    userId: number,
    taskId: number,
    action: TaskAction
  ) => Promise<boolean>
  addGoalTask: (userId: number, task: IAddGoalTask) => Promise<boolean>
}
